import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'LeagueCategory';

const LeagueCategoryApi: any = baseApi(endpoint);

export default LeagueCategoryApi;